import { AppDispatch } from 'store/create-store';
import { updateImageFilename, uploadFile } from 'store/pages/actions';

export const uploadCheckoutPageImage = async (
  dispatch: AppDispatch,
  file: File,
  pageId: number,
  activeRole: string
): Promise<void> => {
  const filename = `tag_${crypto.randomUUID()}.png`;
  const renamedFile = new File([file], filename, { type: 'image' });
  const uploaded = await dispatch(uploadFile(renamedFile));
  if (!uploaded) throw new Error('Checkout page image upload failed');
  await updateImageFilename('page', String(pageId), 'principal_logo', filename, activeRole);
};
